import { observable } from "mobx"

// Annoouncement组件数据
class MessageAnnouncementStore {
  // @observable notifyData = {}
  @observable announcementData = {
    list: [],
    loadingShow: false,
  }

  @observable pageValue = 1
  @observable config = {
    is_home_page: 0,
    page: 1,
    page_size: 10,
  }
}

// Notify组件数据
class MessageNotifyStore {
  @observable tabsValue = 1
  @observable pageValue = 1
  @observable config = {
    page: 1,
    page_size: 10,
    status: undefined,
    cate_id: undefined,
    agency_uid: undefined,
  }
  @observable notifyData = {
    list: [],
    summary: [],
    loadingShow: false,
  }
  @observable agencyList = []
}

class MessageStore {
  @observable tabsValue = 1
  @observable messageAnnouncementStore = new MessageAnnouncementStore()
  @observable messageNotifyStore = new MessageNotifyStore()
}

export default new MessageStore()
